<template>
  <div>
    <div
      class="right-col"
      id="content-area"
      style="width: 100%; margin-left: 0"
    >
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>

      <div v-else-if="paymentBookingData">
        <!-- No card payment booking -->
        <div v-if="!paymentBookingData.cardPayments">
          <h1>{{ $t('booking_sent_title') }}</h1>
          <div v-html="$t('booking_sent_message')" />
        </div>

        <!-- card payment booking -->
        <div v-else-if="paymentBookingData">
          <!-- Already paid? -->
          <template v-if="alreadyPaid">
            <h1>{{ $t('reservation_payment_form_PAID_title') }}</h1>
            <br />
            <div v-html="$t('reservation_payment_form_PAID_message')" />
          </template>
          <template v-else>
            <h1>{{ $t('reservation_payment_form_title') }}</h1>
            <div v-html="$t('reservation_payment_form_message')" />
          </template>
          <br />
        </div>

        <!-- Booking info chips -->
        <div
          v-if="paymentBookingData.objectName || formattedDateStart"
          class="booking-info-chips"
        >
          <div
            v-if="paymentBookingData.objectName"
            class="booking-info-chips__object"
          >
            <i
              class="fa fa-home"
              style="font-size: 16px; color: #219bc8; margin-right: 8px"
            ></i>
            <a
              v-if="objectPageUrl"
              :href="objectPageUrl"
              target="_blank"
              class="booking-info-chips__object-link"
            >
              {{ paymentBookingData.objectName }}
            </a>
            <span v-else>{{ paymentBookingData.objectName }}</span>
          </div>
          <div class="booking-info-chips__row">
            <span
              v-if="formattedDateStart && formattedDateEnd"
              class="booking-info-chip"
            >
              <v-icon
                color="#219bc8"
                small
                class="mr-1"
              >
                mdi-calendar-range
              </v-icon>
              {{ formattedDateStart }} &ndash; {{ formattedDateEnd }}
              <span
                v-if="bookingNights"
                style="opacity: 0.7; margin-left: 3px"
              >
                ({{ bookingNights }} {{ bookingNights === 1 ? $t('öö') : $t('ööd') }})
              </span>
            </span>
            <span
              v-if="bookingGuestsText"
              class="booking-info-chip"
            >
              <v-icon
                color="#219bc8"
                small
                class="mr-1"
              >
                mdi-account-group-outline
              </v-icon>
              {{ bookingGuestsText }}
            </span>
            <span
              v-if="paymentBookingData.reservationFee"
              class="booking-info-chip"
            >
              <v-icon
                color="#219bc8"
                small
                class="mr-1"
              >
                mdi-tag-outline
              </v-icon>
              <strong>{{ $t('reservation_fee') }}: {{ paymentBookingData.reservationFee }} &euro;</strong>
            </span>
          </div>
        </div>
        <br />
      </div>

      <div v-else>Unknown error</div>
    </div>

    <!--    <v-btn @click="processPayment">process</v-btn>-->
    <v-container
      v-if="loadingPaymentFormData"
      fill-height
      class="d-flex justify-center align-center"
    >
      <v-progress-circular
        indeterminate
        color="amber"
        size="25"
        width="2"
      />
    </v-container>

    <form
      v-else-if="
        paymentFormData &&
        paymentBookingData &&
        paymentBookingData.cardPayments &&
        !alreadyPaid
      "
      name="frm"
      :action="paymentFormData.paymentUrl"
      method="POST"
      target="paymentIframe"
      ref="paymentForm"
    >
      <input
        type="hidden"
        name="Ds_SignatureVersion"
        value="HMAC_SHA256_V1"
      />
      <!--      <input-->
      <!--        type="hidden"-->
      <!--        name="Ds_Merchant_ConsumerLanguage"-->
      <!--        :value="merchant_ConsumerLanguage"-->
      <!--      />-->
      <!--      <input-->
      <!--        type="hidden"-->
      <!--        name="Ds_ConsumerLanguage"-->
      <!--        :value="merchant_ConsumerLanguage"-->
      <!--      />-->
      <input
        type="hidden"
        name="Ds_MerchantParameters"
        :value="paymentFormData.Ds_MerchantParameters"
      />
      <input
        type="hidden"
        name="Ds_Signature"
        :value="paymentFormData.Ds_Signature"
      />
      <input
        type="submit"
        value="Proceed to Payment"
        style="display: none"
      />

      <iframe
        v-if="paymentFormData"
        name="paymentIframe"
        width="100%"
        :style="{
          height: 'calc(100vh - 600px)',
          minHeight: isMobileView ? '1800px' : '750px',
        }"
        frameborder="0"
      ></iframe>
    </form>

    <!--    {{ paymentBookingData }}-->
    <!--    <br><br>-->
    <!--    {{ merchantData }}-->
    <!--    <br><br>-->
    <!--    {{ paymentFormData }}-->
  </div>
</template>

<script>
import api from '@/store/api'
import moment from 'moment'
import sharedComputed from '@/methods/sharedComputed'
import state from '@/store/state'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

const uniqueId = () => {
  // Get the current date in YYMMDD format
  const dateSegment = moment().format('YYMMDD') // Example: "231108"

  // Use the last 3 digits of the current milliseconds to guarantee daily uniqueness
  const timeSegment = Date.now().toString().slice(-3) // Example: "123" (last 3 digits of timestamp)

  // Add 3 random digits for further uniqueness
  const randomSegment = Math.floor(Math.random() * 1000)
    .toString()
    .padStart(3, '0') // Example: "456"

  // Combine all parts into a single 12-digit ID
  return dateSegment + timeSegment + randomSegment // Example: "231108123456"
}

export default {
  name: 'PaymentForm',

  data() {
    return {
      loading: false,
      paymentBookingData: null,
      paymentFormData: null,
      loadingPaymentFormData: false,
      checkPaymentInterval: null,
      pendingBookingLocal: null,
    }
  },

  async created() {
    try {
      const raw = localStorage.getItem('pending_booking')
      if (raw) this.pendingBookingLocal = JSON.parse(raw)
    } catch (e) { /* ignore */ }
    await this.fetchPaymentData()
    if (this.paymentBookingData?.cardPayments && !this.alreadyPaid) {
      this.getPaymentFormData()

      this.checkPaymentInterval = setInterval(() => {
        this.checkIfPaid()
      }, 3000)
    }

    window.addEventListener('message', (event) => {
      if (event.data === 'returnOK') {
        this.handleSuccess()
      } else if (event.data === 'returnNOK') {
        this.handleFailure()
      }
    })
  },

  beforeDestroy() {
    if (this.checkPaymentInterval) {
      clearInterval(this.checkPaymentInterval)
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    ...sharedComputed,

    alreadyPaid() {
      return this.paymentBookingData?.reservationFeePaid
    },

    amount() {
      return (this.paymentBookingData?.reservationFee || 0) * 100
    },

    bookingId() {
      return this.$route.params.bookingId
    },

    lang() {
      return this.$store.state.lang
    },

    bookingNo() {
      return this.paymentBookingData?.dateStart
        ? moment(this.paymentBookingData?.dateStart).format('DDMMYY') +
            '-' +
            moment(this.paymentBookingData?.createdAt).format('DDMM')
        : ''
    },

    merchantData() {
      return {
        bookingId: this.bookingId,
        bookingNo: this.bookingNo,
        lang: this.lang,
        amount: this.amount,
        product:
          this.paymentBookingData.customerName +
          ' ' +
          this.paymentBookingData.customerEmail +
          ' ' +
          this.paymentBookingData.objectName +
          ' ' +
          '' +
          moment(this.paymentBookingData.dateStart).format('DD.MM.YY') +
          ' - ' +
          '' +
          moment(this.paymentBookingData.dateEnd).format('DD.MM.YY'),
      }
    },

    formattedDateStart() {
      return this.paymentBookingData?.dateStart
        ? moment(this.paymentBookingData.dateStart).format('DD.MM.YYYY')
        : ''
    },

    formattedDateEnd() {
      return this.paymentBookingData?.dateEnd
        ? moment(this.paymentBookingData.dateEnd).format('DD.MM.YYYY')
        : ''
    },

    bookingNights() {
      if (this.pendingBookingLocal?.nights) return this.pendingBookingLocal.nights
      if (this.paymentBookingData?.dateStart && this.paymentBookingData?.dateEnd) {
        const start = moment(this.paymentBookingData.dateStart)
        const end = moment(this.paymentBookingData.dateEnd)
        return end.diff(start, 'days')
      }
      return 0
    },

    objectPageUrl() {
      if (!this.pendingBookingLocal?.objectSeoName) return null
      return '/' + this.pendingBookingLocal.objectSeoName + '_' + this.$store.state.lang + '_object.html'
    },

    bookingGuestsText() {
      if (!this.pendingBookingLocal) return ''
      const parts = []
      if (this.pendingBookingLocal.adults) {
        parts.push(this.pendingBookingLocal.adults + ' ' + this.$t('adults_count'))
      }
      if (this.pendingBookingLocal.kids) {
        parts.push(this.pendingBookingLocal.kids + ' ' + this.$t('kids_count'))
      }
      if (this.pendingBookingLocal.infants) {
        parts.push(this.pendingBookingLocal.infants + ' ' + this.$t('infants_count'))
      }
      return parts.join(', ')
    },

    merchant_ConsumerLanguage() {
      // TODO
      // Use this.lang ('en', 'es', etc...)
      const languageMapping = {
        es: '1',
        en: '2',
        ca: '3',
        fr: '4',
        de: '5',
        nl: '6',
        it: '7',
        sv: '8',
        pt: '9',
        pl: '11',
        gl: '12',
      }

      // Return the corresponding value from the languageMapping object
      return languageMapping[this.lang] || '2' // Default to '002' for 'en' if not found
    },
  },

  methods: {
    handleSuccess() {
      console.log('success')
      localStorage.removeItem('pending_booking')
      this.fetchPaymentData()
    },

    handleFailure() {
      console.log('failure')
      // Reload page so user can try again
      window.location.reload()
    },

    async fetchPaymentData() {
      if (!this.bookingId) return

      this.loading = true
      try {
        this.paymentBookingData = await api.getOneItem(
          'booking-to-pay',
          this.bookingId
        )
        if (this.paymentBookingData && this.paymentBookingData.reservationFeePaid) {
          localStorage.removeItem('pending_booking')
        }
      } catch (error) {
        console.error('Error fetching payment data', error)
      } finally {
        this.loading = false
      }
    },

    async checkIfPaid() {
      if (!this.bookingId) return
      try {
        const response = await api.getOneItem('booking-to-pay', this.bookingId)
        if (response?.status === 'ok' && response.reservationFeePaid) {
          // When now is paid and was not paid before, should automatically show the message
          // and close the iframe
          this.paymentBookingData = response
          localStorage.removeItem('pending_booking')
          clearInterval(this.checkPaymentInterval)
        }
      } catch (error) {
        console.error('Error checking if payd', error)
      }
    },

    processPayment() {
      const paymentData = {
        amount: this.amount, // Pass the amount prop
        bookingId: this.bookingId, // Pass the bookingId prop
      }

      api
        .apiPostRequest('/testPDF', paymentData)
        .then((response) => {
          if (response.status === 'success') {
            console.log('Payment was processed successfully:', response)
            // Handle success case, e.g., notify the user or proceed further
          } else {
            console.error(
              'Error during payment processing:',
              response.message || response
            )
            // Handle error case
          }
        })
        .catch((error) => {
          console.error('API request failed:', error)
          // Handle API request failure
        })
    },

    getPaymentFormData() {
      this.loadingPaymentFormData = true
      api
        .apiRemoteRequest(
          'https://pay.costasolrent.com/?id=' +
            uniqueId() +
            '&product=' +
            this.merchantData.product +
            '&lang=' +
            this.merchant_ConsumerLanguage +
            '&amount=' +
            this.amount +
            '&mData=' +
            btoa(JSON.stringify(this.merchantData)),
          []
        )
        .then((res) => {
          console.log('res', res)
          this.loadingPaymentFormData = false

          if (res.status === 'success') {
            this.paymentFormData = res
            this.$nextTick(() => {
              if (this.$refs.paymentForm) {
                this.$refs.paymentForm.submit()
                console.log('Form auto-submitted')
              } else {
                console.error('Form not found')
              }
            })
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.booking-info-chips {
  padding: 4px 0;

  &__object {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;
    margin-bottom: 13px;
    margin-left: 12px;
  }

  &__object-link {
    color: #219bc8;
    text-decoration: none;
    font-weight: 600;
    &:hover {
      text-decoration: underline;
    }
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 10px;
  }
}

.booking-info-chip {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  background: #e8f4f8;
  color: #1a1a1a;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 1.4;
}
</style>
